var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {
    },

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function($rowElem) {
                var rowId = $rowElem.data('id');
                return { id: rowId, $el: $rowElem };
            },
            actions: [{
                name: 'Devis öffnen',
                classNames: 'dropdown-item',
                iconClass: 'bi-eye',
                onClick: this.openDevis,
            }, {
                name: 'Devis löschen',
                classNames: 'dropdown-item text-danger',
                iconClass: 'bi-trash',
                onClick: this.deleteDevis,
            }],
        });
    },

    events: [{
        name: 'click',
        el(component) { return component.el.querySelectorAll('.btn-context-click'); },
        handler(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var rowEl = $(ev.target).closest(this.selector);
            this.menu.open(rowEl, ev);
        }
    }],

    methods: {
        openDevis(row) {
            if (row.id) {
                location.href = '/Devis/Default/Edit/' + row.id;
            }
        },
        deleteDevis(row) {
            if (row.id) {
                messaging.askYesNo('Devis löschen', 'Das Devis wird in den Papierkorb verschoben.', function () {
                    var url = '/Devis/Default/DeleteDevis/' + row.id;
                    connection.loadJson(url, null, function () {
                        row.$el.remove();
                        messaging.showGlobalMessage('success', null, 'Das Devis wurde gelöscht.');
                    });
                });
            }
        },
    },

}
